/**
 * Created by dimah on 09/08/17.
 */
import { IAcl, IUser } from "@signature-it/ngx-generic/interfaces";
import { AclDTO } from "./acl";
import { AbstractDTO } from "./abstract";

declare let _: any;

export abstract class AbstractUserDTO extends AbstractDTO implements IUser {
	user_id: number;
	entity_type: string;
	type: string;
    acl: IAcl[];
    user_club: number;
    acmGroups: string[];

    protected constructor(attributes: object) {
        super(attributes);
        attributes = attributes || {};

        this.user_id = Number(attributes["user_id"]) || -1;
        this.entity_type = null;
        this.type = null;
        this.user_club = Number(attributes["user_club"]) || 0;
        this.acmGroups = attributes["acmGroups"] || [];
        this.setAcl(attributes['acl']);
    }

    setAcl(acls: Array<object>) {
        _.each(acls, a => a['checked'] = true);
        this.acl = AclDTO.createFromArray(acls || []);
    }

    hasAcl(aclName: string): boolean {
        const res = _.find(this.acl, {name: aclName});
        return Boolean(res);
    }

    isB2B(): boolean {
        return false;
    }

    isGuest(): boolean {
        return false;
    }

}
